import { render, staticRenderFns } from "./SkillsPanel.vue?vue&type=template&id=99b47086&scoped=true"
import script from "./SkillsPanel.vue?vue&type=script&lang=js"
export * from "./SkillsPanel.vue?vue&type=script&lang=js"
import style0 from "./SkillsPanel.vue?vue&type=style&index=0&id=99b47086&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99b47086",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow})
